// extracted by mini-css-extract-plugin
module.exports = {"root":"VerticalSplit_root__Qv-c1","left":"VerticalSplit_left__RsC6N","right":"VerticalSplit_right__3OxvR"};